import request from '@/utils/request';

// 设备报表
export const getCusPriceStatistics = (params: any) =>
  request({
    url: 'StatisticsCusPrice/price',
    method: 'get',
    params
  });

// 导出excel 设备列表
export const exportCusPriceStatistics = (params: any) =>
  request({
    url: 'StatisticsCusPrice/export',
    method: 'get',
    params
  });
